import { createSlice } from '@reduxjs/toolkit';

import { loginSlice } from '»components/Auth';
import { tokenLanguageCode, tokenLanguageId } from '»utils/jwt';

const initialState = {
  isLoading: false,
  available: [
    {
      dateFormat: 'dd/MM/yyyy',
      expression: 'TRLT_UI-PORTUGUESE',
      image: 'flagang',
      languageId: 'pt-PT',
    },
  ],
};

export const i18nSlice = createSlice({
  name: 'i18nSlice',
  initialState,
  reducers: {
    culturesRequest: (state) => {
      state.isLoading = true;
    },
    culturesSucess: (state, action) => {
      state.isLoading = false;
      state.available = action.payload;
    },
    culturesFailure: (state, action) => {
      const { data, error } = action.payload;
      state.isLoading = false;
      state.data = data;
      state.error = error;
    },
    setUserLanguage: (state, action) => {
      const { languageId, languageCode } = action.payload;

      localStorage.setItem('userLanguageCode', languageCode);
      state.languageId = languageId;
      state.languageCode = languageCode;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginSlice.actions.loginSuccess, (state, action) => {
      const { token } = action.payload;
      state.languageId = tokenLanguageId(token);
      state.languageCode = tokenLanguageCode(token);
    });
  },
});
